module.exports = __webpack_public_path__ + "videos/ramadan-banner-mobile.048578d.mp4";